import { render, staticRenderFns } from "./gl-section.vue?vue&type=template&id=830160be"
import script from "./gl-section.vue?vue&type=script&lang=js"
export * from "./gl-section.vue?vue&type=script&lang=js"
import style0 from "./gl-section.vue?vue&type=style&index=0&id=830160be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports